import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { SearchBarDialog } from '@sorare/core/src/components/navigation/AppNavigation/SearchBar/SearchBarDialog';

export const SearchBarHeaderButton = ({ children }: PropsWithChildren) => {
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  return (
    <>
      <ButtonBase onClick={() => setSearchBarOpen(true)}>
        <Horizontal>
          <IconButton
            size="medium"
            icon={faSearch}
            color="transparent"
            asSpan
          />
          {children}
        </Horizontal>
      </ButtonBase>
      {!!searchBarOpen && (
        <SearchBarDialog onClose={() => setSearchBarOpen(false)} />
      )}
    </>
  );
};
